

































import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({ name: 'v-background' })
export default class VBackground extends Vue {
    @Prop({ type: String, default: 'primary' })
    start!: string

    @Prop({ type: String, default: 'primary' })
    stop!: string
}
